module.exports = __webpack_public_path__ + "img/Tonga.4b132578.svg";